import React, {Component} from 'react';
import {
  Typography,
  SignUpButton,
  Header,
  BodyText,
  SectionFade,
  Fade,
  Background,
  FadeUp,
  Pagination,
  BodyContents,
  PaginationDots,
  Ping,
} from '../components';

class BreatheContainer extends Component {
  render() {
    const {onSignUp, onSelect, isSelected, contents, commonContents, direction, lang, OS} = this.props;
    const {header, body, prev, next} = contents;
    const {background, backgroundColor, timeout} = commonContents;

    const onExited = () => {
      if (direction === 'prev') onSelect(prev);
      if (direction === 'next') onSelect(next);
    };

    return (
      <SectionFade active={isSelected} timeout={timeout.page} timing={500} onExited={onExited}>
        <Background styles={{backgroundColor: backgroundColor}}/>
        <Background background={background} styles={{backgroundPosition: 'center', zIndex: 2}}/>
        {isSelected && (
          <Ping/>
        )}
        <Header OS={OS}>
          <SignUpButton onClick={onSignUp}>
            {header.signUp}
          </SignUpButton>
        </Header>
        <BodyText>
          <FadeUp
            timeout={timeout.header}
            timing={500}
            active={isSelected}
          >
            <Typography size={'large'} bold styles={lang === 'ko' ? {letterSpacing: '-1px'}: null}>
              {body.header}
            </Typography>
          </FadeUp>
          <FadeUp
            timeout={timeout.description}
            timing={500}
            active={isSelected}
            customStyles={{marginBottom: '11px'}}
          >
            <Typography styles={lang === 'ko' ? {letterSpacing: '-0.7px'}: null}>
              {body.description}
            </Typography>
          </FadeUp>
        </BodyText>
        <BodyContents/>
        <Pagination customStyle={{zIndex: 3}}>
          <Fade active={isSelected} timeout={timeout.description} timing={500}>
            <PaginationDots length={5} current={4}/>
          </Fade>
        </Pagination>
      </SectionFade>
    );
  }
}

export default BreatheContainer;


// WEBPACK FOOTER //
// ./src/app/intro/containers/BreatheContainer.js